export default __webpack_public_path__ + "static/media/LAS0860.34I-39520_-23417_0.24cc8c28.jpg";